import { createSelector } from '@reduxjs/toolkit';
import { Car } from '@lib/azgaz-ui/connect';
import { getSpecification } from '@azgaz/azgaz-ui';
import { State } from '../apps/appCreator/store';
import getVehicles from './getVehicles';

const getCatalogGradeByCar = createSelector(
  getVehicles,
  (state: State, car: Car | undefined) => car,
  ({ vehicles }, currentCar) => {
    if (!vehicles || !currentCar) return;

    const {
      _original: {
        specification: { model_category_code: model },
      },
      grade,
      specification,
    } = currentCar;

    const currentVehicle = vehicles.find(
      ({ name }) => name.toUpperCase() === model?.toUpperCase()
    );

    if (!currentVehicle) return;

    const generation: number = getSpecification(
      specification,
      'other',
      'generation'
    );

    const currentModification = currentVehicle.modifications.find(
      ({ modelYears }) => modelYears.find(year => +year === +generation)
    );

    if (!currentModification) return;

    const currentGrade = currentModification.grades.find(
      ({ name }) => name === grade
    );

    // eslint-disable-next-line consistent-return
    return currentGrade;
  }
);

export default getCatalogGradeByCar;
